import React from 'react';
import { Wrapper, PaperStyled } from './index.styles';
import NexLogoTitle from 'components/assets/nex-logo-title/nex-logo-title';

const LayoutAuth: React.FC = ({ children }) => {
    return (
        <Wrapper>
            <div>
                <NexLogoTitle />
            </div>
            <div>
                <PaperStyled>{children}</PaperStyled>
            </div>
        </Wrapper>
    );
};

export default LayoutAuth;
